import { MenuItems, menuItems } from "@/config/menu";
import routes from "@/routers/routes";
import Breadcrumb from "@/ui/breadcrumb";
import cn from "@/utils/class-names";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Title } from "rizzui";

export type PageBreadTypes = {
    title: string;
    className?: string;
};

export default function PageBread({
    title,
    children,
    className,
}: React.PropsWithChildren<PageBreadTypes>) {
    const location = useLocation();

    const [_isHide, setIsHide] = useState(false);
    const [_groupTitle, setGroupTitle] = useState("");
    const [currentMenu, setCurrentMenu] = useState<MenuItems>();
    const [dashboardMenu, setDashboardMenu] = useState<MenuItems>();

    useEffect(() => {
        const currentMenu = menuItems.find(
            (item) => item.href === location.pathname,
        );

        const dashboardMenu = menuItems.find(
            (item) => item.href === routes.dashboards.index,
        );

        const currentChild = menuItems.find((item) =>
            item.dropdownItems?.find(
                (child) => child.href === location.pathname,
            ),
        );

        if (dashboardMenu) {
            setDashboardMenu(dashboardMenu);
        }

        if (currentMenu) {
            setCurrentMenu(currentMenu);
            setIsHide(currentMenu?.isHidden ?? false);
        } else if (currentChild) {
            setIsHide(currentChild?.isHidden ?? false);
            setGroupTitle(currentChild?.name);
        }
    }, [location, location.pathname]);

    return (
        <header className={cn("mb-6 @container xs:-mt-2 lg:mb-7", className)}>
            <div className="flex flex-col @lg:flex-row @lg:items-center @lg:justify-between">
                <div>
                    <Title
                        as="h2"
                        className="mb-2 text-[22px] lg:text-2xl 4xl:text-[26px]"
                    >
                        {title}
                    </Title>

                    <Breadcrumb
                        separator=""
                        separatorVariant="circle"
                        className="flex-wrap"
                    >
                        {[dashboardMenu, currentMenu].map((item, i) => (
                            <Breadcrumb.Item
                                key={item?.name ?? `group${i}`}
                                {...(item?.href && { href: item?.href })}
                            >
                                {item?.name}
                            </Breadcrumb.Item>
                        ))}
                    </Breadcrumb>
                </div>
                {children}
            </div>
        </header>
    );
}
